/** Номер страницы списка обращений в query string (`?page=`) — синхронизируется с вкладками и «Назад». */

export const TICKETS_LIST_PAGE_QUERY = 'page'

export function parseTicketsListPageFromSearch(search: string): number {
  const q = search.startsWith('?') ? search.slice(1) : search
  const p = new URLSearchParams(q)
  const raw = p.get(TICKETS_LIST_PAGE_QUERY)
  if (raw == null || raw === '') return 1
  const n = parseInt(raw, 10)
  if (Number.isNaN(n) || n < 1) return 1
  return n
}

export function stripTicketsListPageParam(p: URLSearchParams): void {
  p.delete(TICKETS_LIST_PAGE_QUERY)
}
